export default "__VITE_ASSET__D3ki0GHS__"